import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslator, DietIdEnum } from '@front-activerse/common-components';
import { dietSettings } from '../types';
import useSteps from '../StepContext/useSteps';
import { Alert } from 'reactstrap';

export const Summary: React.FC = () => {
  const { t } = useTranslator();
  const { values } = useFormikContext<dietSettings>();
  const { dietType, dietLevel } = values;
  const { dietTypes, dietLevels } = useSteps();

  const macroDietType = dietTypes.find((type) => type.value === dietType)?.macro;

  let macroDietLevel;
  if (dietLevels) {
    macroDietLevel = dietLevels.find((type) => type.value === dietLevel)?.macro;
  }

  return (
    <>
      <h2 className="mb-m title-large semi-bold">{t('goalSettings.summary.headline')}</h2>
      <p className="mb-xl text-text-variant-color">{t('goalSettings.summary.description')}</p>
      <div>
        <dl>
          <dt>{t('app.goalSettings.summary.list.dietType')}</dt>
          <dd>{dietType && t(`app.goalSettings.summary.list.dietType.${dietType}`)}</dd>
        </dl>

        {dietLevel && dietType === DietIdEnum.DIET_ID_CLASSIC ? (
          <>
            <dl>
              <dt>{t('app.goalSettings.summary.list.dietLevel')}</dt>
              <dd>{dietType && t(`app.goalSettings.summary.list.dietLevel.${dietLevel}`)}</dd>
            </dl>

            <dl>
              <dt>{t('nutritionSettings.summary.list.macros')}</dt>
              <dd>
                {t('summary.macros.proteinsShort')} {macroDietLevel?.protein}%{', '}
                {t('summary.macros.fatsShort')} {macroDietLevel?.fat}%{', '}
                {t('summary.macros.carbsShort')} {macroDietLevel?.carbs}%
              </dd>
            </dl>
          </>
        ) : (
          <dl>
            <dt>{t('nutritionSettings.summary.list.macros')}</dt>
            <dd>
              {t('summary.macros.proteinsShort')} {macroDietType?.protein}%{', '}
              {t('summary.macros.fatsShort')} {macroDietType?.fat}%{', '}
              {t('summary.macros.carbsShort')} {macroDietType?.carbs}%
            </dd>
          </dl>
        )}
      </div>

      <Alert color="info" fade={false} className="mt-xl">
        <p className="small">{t('goalSettings.summary.changeMealsNotification')}</p>
      </Alert>
    </>
  );
};

export default Summary;
